import React, { useEffect, useRef, useState } from 'react'
import { TextareaProps } from './types/index'
import * as rawStyles from './styles.module.scss'

const Textarea = ({
    id,
    name,
    required,
    placeholder,
    defaultValue,
    disabled,
    error,
    errorMessage,
    onChange,
    onBlur,
}: TextareaProps) => {
    const styles: any = rawStyles
    const ref = useRef(null)

    let value = ''
    const [filled, setFilled] = useState(false)

    useEffect(() => {
        if (ref.current) {
            const input: HTMLInputElement = ref.current
            value = input.value
        }
        if (!value) setFilled(false)
    }, [value])

    useEffect(() => {
        if (ref?.current) {
            // avoid native input validation error messages & submit
            const element: HTMLInputElement = ref.current
            element.addEventListener('invalid', (e) => e.preventDefault(), true)
            element.addEventListener('submit', (e) => e.preventDefault(), true)
            return () => {
                element.removeEventListener('invalid', (e) => e.preventDefault(), true)
                element.removeEventListener('submit', (e) => e.preventDefault(), true)
            }
        }
    }, [ref?.current])

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (e.target.value) setFilled(true)
        else setFilled(false)

        if (onChange) onChange(e)
    }

    return (
        <>
            <div className={styles.c_textarea} data-is-filled={filled} data-is-error={!!error}>
                <textarea
                    ref={ref}
                    className={styles.textarea}
                    name={name}
                    key={id}
                    id={id}
                    data-testid={id}
                    defaultValue={defaultValue}
                    onChange={handleChange}
                    onBlur={onBlur}
                    disabled={disabled}
                    required={required}
                />
                <label className={styles.label} htmlFor={id} data-testid={`${id}-label`}>
                    {placeholder}
                </label>
            </div>
            {error && errorMessage && (
                <div className={styles.error}>
                    <p key={errorMessage}>{errorMessage}</p>
                </div>
            )}
        </>
    )
}

export default Textarea
